import { render } from "./IndexHero.vue?vue&type=template&id=1e318ac2"
import script from "./IndexHero.vue?vue&type=script&lang=js"
export * from "./IndexHero.vue?vue&type=script&lang=js"

import exportComponent from "/opt/microsoft-academy/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__